
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Transaction } from '~/interfaces/transactions';

@Component
export default class TransactionsTableItem extends Vue {
  @Prop({ type: Object, default: null }) readonly data!: Transaction;

  @Prop(Boolean) readonly colorCodedNegatives!: boolean;

  $refs!: { content: HTMLElement };

  expanded = false;

  get maxHeight() {
    return this.expanded ? `${this.$refs.content.scrollHeight}px` : 0;
  }

  get amount() {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    });

    return formatter.format(this.data.amount);
  }

  get getAmountClasses() {
    if (this.data.status === 'Failed') {
      return 'transactions-table-item__amount--failed';
    }

    if (this.colorCodedNegatives && this.data.amount < 0) {
      return 'transactions-table-item__amount--color-coded';
    }

    return '';
  }
}
